import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/OutstandingSalesInvoiceReport/ARReportOutstandingInvoiceAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ARReportOutstandingInvoiceActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/OutstandingSalesInvoiceReport/ARReportOutstandingInvoice")
	}

	render() {
		return (
			<Activity 
				name="ARReportOutstandingInvoice"
				RenderedComponent={this.RenderedComponent}
				context="ARReportOutstandingInvoice"
				action="ARReportOutstandingInvoice"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ARReportOutstandingInvoiceActivity)
